import styled from 'styled-components'
import { FaTimes } from 'react-icons/fa'

interface IProps {
  children: JSX.Element | JSX.Element[]
  className?: string
  showCloseButton?: boolean
  onClose?: () => void
}

const AccountModalLayout = ({ children, onClose, className, showCloseButton = true }: IProps) => {
  return (
    <Section>
      <section className={`account-modal-container ${className}`}>
        {showCloseButton && (
          <span className="close-btn" onClick={onClose}>
            <FaTimes size={12} />
          </span>
        )}
        {children}
      </section>
    </Section>
  )
}

const Section = styled.section`
  z-index: ${({ theme }) => theme.zIndex.modal};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.grey.dark}50;
  section.account-modal-container {
    position: relative;
    width: ${({ theme }) => theme.util.pixelToRem(493)};
    border: 1px solid ${({ theme }) => theme.colors.primary.lightest};
    border-radius: ${({ theme }) => theme.borderRadius.rounded};
    background-color: ${({ theme }) => theme.colors.grey.lightest};
    padding: 3rem ${({ theme }) => theme.util.pixelToRem(72)} 1.5rem;
    .close-btn {
      position: absolute;
      color: ${({ theme }) => theme.colors.primary.neutral};
      top: 1.5rem;
      right: 1.5rem;
      cursor: pointer;
    }
  }
`

export { AccountModalLayout }
